import React from "react";

const LOGO_URL =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_cross-columbia/artifacts/xw7s2dsh_12.png";

/**
 * BrandMark — official BridgeColumbia mark.
 * White chat-bubble line-art on transparent background so it drops
 * cleanly onto the dark teal palette.
 */
export default function BrandMark({ className = "w-10 h-10" }) {
  return (
    <img
      src={LOGO_URL}
      alt="BridgeColumbia"
      className={className}
      draggable={false}
    />
  );
}
